// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3wPOf","signatureBlock":"Footer_signatureBlock__3wFbV","signature":"Footer_signature__yvGF6"};